// hooks-suggestion/useObjectiveSuggestions.js - SANS INDEX.JSON
import { useEffect, useState } from 'react';

// Import SEULEMENT du fichier qui fonctionne + les nouveaux
import patrimoineImmobilierData from '../../../../data-objectives/categories/patrimoine-immobilier.json';
import reseauVisibiliteData from '../../../../data-objectives/categories/reseau-visibilite.json';
import revenusLocatifsData from '../../../../data-objectives/categories/revenus-locatifs.json';
import strategiesImmobilieresData from '../../../../data-objectives/categories/strategies-immobilieres.json';

// Mapping avec tous les fichiers
const CATEGORIES_DATA = {
    'patrimoine-immobilier': patrimoineImmobilierData,
    'revenus-locatifs': revenusLocatifsData,
    'strategies-immobilieres': strategiesImmobilieresData,
    'reseau-visibilite': reseauVisibiliteData
};

export const useCategoryObjectives = (categoryValue) => {
    const [categoryObjectives, setCategoryObjectives] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!categoryValue || categoryValue === 'autres') {
            setCategoryObjectives([]);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const categoryData = CATEGORIES_DATA[categoryValue];

            if (!categoryData) {
                setCategoryObjectives([]);
                setError(`Catégorie ${categoryValue} non trouvée`);
            } else {
                setCategoryObjectives(categoryData.objectives || []);
            }

            setLoading(false);

        } catch (err) {
            setError(err.message);
            setCategoryObjectives([]);
            setLoading(false);
        }
    }, [categoryValue]);

    return { categoryObjectives, loading, error };
};

// Hook principal
export const useObjectiveSuggestions = () => {
    const [objectiveSuggestions, setObjectiveSuggestions] = useState([]);
    const [categoriesData, setCategoriesData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            const allSuggestions = [];

            // Traiter chaque catégorie
            Object.entries(CATEGORIES_DATA).forEach(([categoryValue, categoryData]) => {
                if (categoryData && categoryData.objectives) {
                    // Info de catégorie depuis les données ou config par défaut
                    const categoryInfo = getCategoryInfo(categoryValue) || {
                        name: categoryData.category?.name || categoryValue,
                        icon: categoryData.category?.icon || '📋',
                        unit: categoryData.category?.unit || ''
                    };

                    categoryData.objectives.forEach(objective => {
                        allSuggestions.push({
                            ...objective,
                            categoryId: categoryValue,
                            categoryName: categoryInfo.name,
                            categoryIcon: categoryInfo.icon,
                            categoryUnit: categoryInfo.unit
                        });
                    });
                }
            });

            setCategoriesData(CATEGORIES_DATA);
            setObjectiveSuggestions(allSuggestions);
            setLoading(false);

        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    }, []);

    return { objectiveSuggestions, categoriesData, loading, error };
};

// Services utilitaires - SANS DÉPENDANCE À INDEX.JSON
export const getCategoriesIndex = () => {
    // Retourner la config en dur des catégories
    return [
        { value: 'patrimoine-immobilier', name: 'Patrimoine Immobilier', icon: '🏢', unit: '€' },
        { value: 'revenus-locatifs', name: 'Cash Flow Immobilier', icon: '🏠', unit: '€' },
        { value: 'strategies-immobilieres', name: 'Compétences & Stratégies', icon: '🎓', unit: '' },
        { value: 'reseau-visibilite', name: 'Réseau & Visibilité', icon: '🤝', unit: '' }
    ];
};

export const getCategoryInfo = (categoryValue) => {
    return getCategoriesIndex().find(cat => cat.value === categoryValue) || null;
};

export const loadCategoryObjectives = async (categoryValue) => {
    const categoryData = CATEGORIES_DATA[categoryValue];
    return categoryData?.objectives || [];
};

export const getObjectivesByCategory = (categoryValue) => {
    const categoryData = CATEGORIES_DATA[categoryValue];
    return categoryData?.objectives || [];
};

export const getCategoryByValue = (value) => {
    const categoryInfo = getCategoryInfo(value);
    return categoryInfo || null;
};

export const getObjectiveById = (categoryValue, objectiveId) => {
    const categoryData = CATEGORIES_DATA[categoryValue];
    if (!categoryData || !categoryData.objectives) return null;
    return categoryData.objectives.find(obj => obj.id === objectiveId) || null;
};

export const getFilteredSuggestions = (categoryObjectives, excludeObjectives = []) => {
    try {
        if (!Array.isArray(categoryObjectives)) return [];

        return categoryObjectives.filter(suggestion =>
            !excludeObjectives.some(existing =>
                existing.name === suggestion.name ||
                existing.target === suggestion.target ||
                existing.id === suggestion.id
            )
        );
    } catch (error) {
        return [];
    }
};